import { render, staticRenderFns } from "./RecordViewer.vue?vue&type=template&id=4d82e262&scoped=true&"
import script from "./RecordViewer.vue?vue&type=script&lang=js&"
export * from "./RecordViewer.vue?vue&type=script&lang=js&"
import style0 from "./RecordViewer.vue?vue&type=style&index=0&id=4d82e262&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d82e262",
  null
  
)

export default component.exports